import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { tabs } from 'src/app/dummy/tabs';
import { DataService } from 'src/app/services/data.service';
import { AddCampusComponent } from './add-campus/add-campus.component';
import { List } from 'src/app/stores/administrator/list.store';

@Component({
  selector: 'app-campus',
  templateUrl: './campus.component.html',
  styleUrls: ['./campus.component.scss']
})
export class CampusComponent implements OnInit {
  tabs = tabs.CAMPUS

  constructor(
    private router: Router,
    public store: List,
    public ds: DataService,
    public dialog: MatDialog) { }

  create(event) {
    const dialogRef = this.dialog.open(AddCampusComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  ngOnInit() {
    this.store.fetchData(this.ds.campusRef(ref => ref.orderBy("name")))
  }

  ngOnDestroy() {
    this.store.dispost();
  }
}
